import * as $ from 'jquery';

export default class SmoothScroll {
	private smoothScrollEvent(event: Event): void {
		event.preventDefault();
		const anchor = <HTMLAnchorElement>event.currentTarget;

		$('html, body').animate({
			scrollTop: $('#' + anchor.hash.substr(1)).offset().top
		}, 1000);
	}
	public add(elements: string): void {
		$(elements).on(<any>'click', this.smoothScrollEvent);
	}
}
